export const GAUGE_PERCENTAGES = [
  { completed: 8 },
  { completed: 16 },
  { completed: 24 },
  { completed: 32 },
  { completed: 40 },
  { completed: 48 },
  { completed: 56 },
  { completed: 64 },
  { completed: 72 },
  { completed: 80 },
  { completed: 88 },
  { completed: 96 },
];
